import { Box, Button, Paper, TextField } from "@mui/material";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { Post } from "../config/apimethods/apimethods";
import logo from "../assets/logo.png";
import BAButton from "../config/components/BAButton";
import BAShowError from "../config/components/BAShowerror";
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

function Login() {
  const [model, setModel] = useState({});
  const [isLoading, setLoader] = useState(false);
  const [showError, setShowError] = useState(false);
  const [message, setMessage] = useState();
  const navigate = useNavigate();

  let login = () => {
    setLoader(true);
    Post("https://mubashircurtainrecieptbackend.vercel.app/api/user/login", model)
      .then((success) => {
        console.log(success);
        if (success.status) {
          setLoader(false);
          localStorage.removeItem("mubashirCurtainToken");
          localStorage.setItem("mubashirCurtainToken", success.token);
          let obj = JSON.stringify(success.data)
          localStorage.setItem("mubashirCurtainUser", obj);
          navigate("/");
          window.location.reload(false);
        } else {
          setLoader(false);
          setMessage(success.errors);
          setShowError(true);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  let fillModel = (key, val) => {
    model[key] = val;
    setModel({ ...model });
  };
  return (
    <>
      <BAShowError
        message={message}
        open={showError}
        close={(e) => setShowError(e)}
      />
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "space-between",
          background: 'linear-gradient(to right,#cce3de,white)'
        }}
        className="bgLight"
      >
        <Box className="w-50 webView flex-column justify-content-around p-5" sx={{ height: "100%", minHeight: "100vh" }}>
          <div className="py-3">
            <img className="shadow" src={logo} width={120} alt="" />
          </div>
          <div>
            <h2>Mubashir Curtain</h2>
            <p className="fs-5">The Shop where you will get Quality in reasonable price</p>
          </div>
          <div>
            <a className="socialLink" target="_blank" href="https://www.facebook.com/mubashircurtain786">
              <FacebookIcon />
            </a>
            <a className="socialLink" target="_blank" href="https://wa.link/ql2a0v">
              <WhatsAppIcon />
            </a>
          </div>
        </Box>
        <Box
          sx={{ height: "100%", minHeight: "100vh" }}
          className="bg-white text-center p-2 d-flex align-items-center justify-content-center"
        >
          <Box>
            <Box sx={{ padding: 2, width: 350 }}>
              <Box className="mobileView">
                <Box className="py-3">
                  <img className="shadow" src={logo} width={100} alt="" />
                </Box>
                <Box>
                  <h2>Mubashir Curtain</h2>
                </Box>
              </Box>

              <Box className="text-center">
                <h2>Login</h2>
              </Box>
              <Box sx={{ padding: 2 }}>
                <TextField
                  disabled={isLoading}
                  fullWidth={true}
                  variant='filled'
                  label="User Name"
                  onChange={(e) => fillModel("userName", e.target.value)}
                />
              </Box>
              <Box sx={{ padding: 2 }}>
                <TextField
                  disabled={isLoading}
                  fullWidth={true}
                  label="Password"
                  type="password"
                  variant="filled"
                  onChange={(e) => fillModel("password", e.target.value)}
                />
              </Box>
              <Box sx={{ padding: 2 }}>
                <BAButton fullWidth={true} label="Login" onClick={login} loading={isLoading} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box >
    </>
  );
}
export default Login;
